<template>
  <AccessHandler
    :requiredRoleGroups="roleGroups"
    @accessChanged="(a: boolean) => (hasAccess = a)"
  />
  <div class="trip-log-details-page" data-cy="trip-log-details-page">
    <MasterPage :subApplication="SubApplicationTypes.ALL_FEATURES">
      <template v-if="hasAccess" v-slot:content>
        <header class="page__header--container clearfix">
          <h1 class="page__title--text pull-left">Trip Log Details</h1>
        </header>
        <TripLogDetailsView />
        <GlobalFooter />
      </template>
    </MasterPage>
  </div>
</template>

<script setup lang="ts">
import MasterPage from "@/views/MasterPage.vue";
import GlobalFooter from "@/views/GlobalFooter.vue";
import AccessHandler from "@/shared/access/AccessHandler.vue";
import type { RoleGroup } from "@/shared/access/RoleGroups";
import { ref } from "vue";
import { SubApplicationTypes } from "@/Domain/SubApplicationTypes";
import TripLogDetailsView from "./TripLogDetailsView.vue";
import { UserRoles as Roles } from "@/Domain/UserRoles";

const roleGroups = [
  {
    roles: [
      Roles.ROLE_MIS,
      Roles.ROLE_IN_HOUSE_MIS_MANAGER,
      Roles.ROLE_ACCOUNTING,
    ],
  },
] as RoleGroup[];

const hasAccess = ref<boolean>(false);
</script>

<style lang="scss">
.trip-log-details-page {
  @media print {
    .global-footer,
    .main-header {
      display: none;
    }
  }
}

</style>

<style scoped lang="scss">
.trip-log-details-view {
  padding: 0 30px 30px;
}

@media print {
  @page {
    size: landscape;
  }
}
</style>
